module.exports = __webpack_public_path__ + "img/cad.e7d4fc7.svg";